module.exports = __webpack_public_path__ + "img/@logo_pintel@3x.ec498947.png";